import React, { useEffect } from "react";
import { connect } from "react-redux";
import { generateHDEAnalysis, updatePercentageStatus } from "../../../../store/modules/qualityOfEarnings/actions";
import Matrix from "./MatrixComponent";
import YearBar from "../YearBar";
import Subtitle from "../Subtitle";
import Item from "./Item";

function HDEAnalysis({
  currentCompanyHDEAnalysis,
  dispatchGenerateHDEAnalysis,
  dispatchUpdatePercentageStatus,
}) {
  // Mounted
  useEffect(() => {
    dispatchGenerateHDEAnalysis();
  }, []);

  const handleChange = (value = false) => {
    dispatchUpdatePercentageStatus(value);
  };
  
  return (
    <div>
      {currentCompanyHDEAnalysis &&
        <div>
          <div className="flex items-center justify-between">
            <h2 className="flex sectionHead">Discretionary Earnings Survey</h2>
            <div className="switch-container">
              <label className="switch">
                <input
                  type="checkbox"
                  defaultChecked={currentCompanyHDEAnalysis.percentage}
                  onChange={(e) => handleChange(e.target.checked)}
                />
                <span className="slider round"></span>
              </label>
              <div className="flex switch-text">Percentage</div>
            </div>
          </div>

          <div className="pb-10">
            <Subtitle title="EBITDA" />
            <YearBar data={currentCompanyHDEAnalysis?.yearsFormatted} />
            <Item name="Sales Revenue" bold={true} manuality={currentCompanyHDEAnalysis.independence === "MANUAL"} />
            {currentCompanyHDEAnalysis.independence === "MANUAL" &&
              <>
                <Item name="Net Income" manuality={true} />
                <Item name="Interest" manuality={true} />
                <Item name="Taxes" manuality={true} />
                <Item name="Depreciation" manuality={true} />
                <Item name="Amortization" manuality={true} />
              </>
            }
            <Item name="EBITDA as Defined" bold={true} />
          </div>

          <Matrix labelTitle="Ownership Salary" />
          <Matrix labelTitle="Owner Retirement Contributions" />
          <Matrix labelTitle="Owner Health & Insurance Benefits" />
          <Matrix labelTitle="Non-Operating Expenses" />
          <Matrix labelTitle="Non-Recurring Expenses" />
          <Matrix labelTitle="Over & Under Payment Adjustments" />

          <div className="pb-10">
            <Subtitle title="Discretionary Earnings Survey Summary" />
            <YearBar data={currentCompanyHDEAnalysis?.yearsFormatted} />
            <Item name="EBITDA as Defined" />
            <Item name="Ownership Salary and Payroll Taxes" />
            <Item name="Owner Retirement Contributions" />
            <Item name="Owner Health & Insurance Benefits" />
            <Item name="Non-Operating Expenses" />
            <Item name="Non-Recurring Expenses" />
            <Item name="Over & Under Payment Adjustments" />
            <Item name="Discretionary Owner Earnings" bold={true} />
          </div>
        </div>
      }
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyHDEAnalysis: state.qualityOfEarnings.currentCompanyHDEAnalysis,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateHDEAnalysis() {
    await dispatch(generateHDEAnalysis());
  },
  async dispatchUpdatePercentageStatus(value) {
    await dispatch(updatePercentageStatus(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(HDEAnalysis);
